export enum CannedResponseType {
  NOTES = 'NOTES',
  DELAY = 'DELAY',
}
